<template>
  <div></div>
</template>
<script>
import { META_INFO_DEFAULT_OG_URL, META_INFO_DEFAULT_TITLE } from '@/common/constant'
import { get } from 'lodash'
export default {
  name: 'Meta',
  props: {
    contentInfo: {
      type: Object
    }
  },
  metaInfo () {
    return {
      htmlAttrs: {
        lang: 'ko-KR',
        dir: 'ltr'
      },
      title: META_INFO_DEFAULT_TITLE,
      meta: [
        { charset: 'utf-8' },
        // SEO 설정
        { hid: 'description', name: 'description', content: this.description, vmid: 'description' },
        { hid: 'keywords', name: 'keywords', content: this.keywords, vmid: 'keywords' },
        // SNS 설정
        {
          hid: 'og:type',
          property: 'og:type',
          content: this.ogType, //
          vmid: 'og:type'
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.ogTitle,
          vmid: 'og:title'
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.ogDescription,
          vmid: 'og:description'
        },
        {
          hid: 'og:image:secure_url',
          property: 'og:image:secure_url',
          content: this.ogImageSecureUrl,
          vmid: 'og:image:secure_url'
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.ogImage,
          vmid: 'og:image'
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: META_INFO_DEFAULT_OG_URL + this.$route.fullPath,
          vmid: 'og:url'
        }
      ]
    }
  },
  computed: {
    ogType () {
      const section = this.$route.params.section
      let type = ''
      if (section === 'vod' || section === 'live' || section === 'clip') {
        type = 'video.episode'
      } else if (section === 'movie') {
        type = 'video.movie'
      }
      return type
    },
    ogTitle () {
      let title = ''
      switch (this.$route.params.section) {
        case 'vod' :
          title = `[wavve]${this.contentInfo.programtitle}`
          break
        case 'live':
          title = `[wavve]${this.contentInfo.title}`
          break
        case 'clip':
          title = `[wavve]${this.contentInfo.programtitle}`
          break
        case 'movie' :
          title = `[wavve]${this.contentInfo.title}`
          break
      }
      return title
    },
    ogDescription () {
      let description = ''
      switch (this.$route.params.section) {
        case 'vod' :
          description = `${this.contentInfo.episodenumber} 회 ${this.contentInfo.episodetitle}`
          break
        case 'live':
          description = ''
          break
        case 'clip':
          description = this.contentInfo.cliptitle
          break
        case 'movie' :
          description = ''
          break
      }
      return description
    },
    ogImageSecureUrl () {
      return 'https://' + (this.contentInfo.image.replace('http://', '').replace('https://', ''))
    },
    ogImage () {
      return 'http://' + (this.contentInfo.image.replace('http://', '').replace('https://', ''))
    },
    keywords () {
      const tagList = get(this.contentInfo, ['tags', 'list'], [])
      return tagList.map((tag) => {
        return get(tag, 'text', '')
      }).join(', ')
    }
  }
}
</script>
